@if (details$ | async; as details) {
  <div class="grid grid-cols-1 gap-3">
    <div class="col-span-2">
      <app-details-view label="Czas ważności ankiety w godzinach">
        {{ details.validityHours }}
      </app-details-view>
    </div>

    <div class="col-span-2">
      <app-details-view label="Opis">
        @if (details.description) {
          <app-summernote-html-preview [html]="details.description" />
        } @else {
          <app-no-data />
        }
      </app-details-view>
    </div>

    <div class="col-span-2">
      <app-details-view label="Grupy zawartości">
        <app-admin-box-sale-groups-preview [groups]="details.groups.items" />
      </app-details-view>
    </div>

    <div class="col-span-2">
      <app-details-view label="Warianty">
        @if (isNotEmptyArray(details.variants)) {
          <div class="rounded-lg border border-gray-200 p-4">
            <p-accordion [multiple]="true">
              @for (
                variant of details.variants;
                track variant.id;
                let index = $index
              ) {
                <p-accordion-panel [value]="index">
                  <p-accordion-header>
                    <div class="flex items-center gap-2 text-sm text-gray-400">
                      <span>#{{ index + 1 }}</span>
                      <span>{{ variant.name }}</span>
                    </div>
                  </p-accordion-header>

                  <p-accordion-content class="overflow-x-auto">
                    <app-box-component-group-cosmetics-table
                      [items]="variant.cosmetics"
                      [showAvailableQuantity]="false"
                      [showRemainingQuantity]="false" />
                  </p-accordion-content>
                </p-accordion-panel>
              }
            </p-accordion>
          </div>
        } @else {
          <app-no-data />
        }
      </app-details-view>
    </div>
  </div>
} @else {
  <app-spinner-filled />
}
